import { render, staticRenderFns } from "./pedido-detalles.vue?vue&type=template&id=3dddf849&"
import script from "./pedido-detalles.vue?vue&type=script&lang=js&"
export * from "./pedido-detalles.vue?vue&type=script&lang=js&"
import style0 from "./pedido-detalles.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports